import React from 'react';
import mobileEPLogo from '../img/mobile-logo-ep.svg';

function MobileHeader(props) {
    return (
        <div className='mobile-nav'>
            <button className="sidebar-toggle" onClick={()=>props.sidebartoggle()}><i className="fas fa-bars"></i></button>
                <img className= "mobile-logo" src={mobileEPLogo} alt="brand-logo" />
                <h2 className= "mobile-header">Student portal</h2>
                <p className= "mobile-name">{props.student.fullname}</p>
        </div>
    );
}

export default MobileHeader;